import { User } from "src/types/userTypes";

/** Accounts on this domain belong to Nuclearn staff, not to a customer. */
export const INTERNAL_EMAIL_DOMAIN = "@nuclearn.ai";

/** The leading `@` anchors the match so lookalikes like `evil-nuclearn.ai` fail. */
export const isInternalEmail = (email?: string | null): boolean =>
  typeof email === "string" &&
  email.trim().toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN);

/**
 * True when the signed-in user holds a Nuclearn staff account.
 *
 * Reads localStorage directly instead of `useGetUserDetails` so class
 * components can call it and so a missing user never triggers that hook's
 * forced logout. `username` carries the user's email address.
 */
export const isInternalUser = (): boolean => {
  try {
    const stored = localStorage.getItem("nuclearn_user");
    if (!stored || stored === "undefined") return false;
    return isInternalEmail((JSON.parse(stored) as Partial<User>).username);
  } catch {
    return false;
  }
};
